/*
 * Home Header — mobile drawer toggle.
 * Source: eik home desktop/EarnItKid Home Desktop.html lines 3633-3648.
 *
 * Theme Editor support: re-binds when the section is re-rendered via the
 * Section Rendering API on `shopify:section:load`. Uses dataset flags to
 * stay idempotent so repeated bind() calls never stack duplicate listeners.
 */
(function () {
  function openMenu(scope) {
    var drawer = scope.querySelector('#menu-drawer');
    var overlay = scope.querySelector('#menu-overlay');
    if (drawer) drawer.classList.add('open');
    if (overlay) overlay.classList.add('open');
  }

  function closeMenu(scope) {
    var drawer = scope.querySelector('#menu-drawer');
    var overlay = scope.querySelector('#menu-overlay');
    if (drawer) drawer.classList.remove('open');
    if (overlay) overlay.classList.remove('open');
  }

  function bindDrawer(scope) {
    var root = scope || document;

    var menuBtn = root.querySelector('#menu-btn');
    var menuClose = root.querySelector('#menu-close');
    var menuOverlay = root.querySelector('#menu-overlay');
    var menuDrawer = root.querySelector('#menu-drawer');

    if (!menuBtn || !menuDrawer || !menuOverlay) return;

    // The scope for state-changes should be the document so all bits stay in sync,
    // even if `scope` happens to be a smaller subtree.
    if (menuBtn.dataset.bound !== '1') {
      menuBtn.dataset.bound = '1';
      menuBtn.addEventListener('click', function () {
        openMenu(document);
      });
    }

    if (menuClose && menuClose.dataset.bound !== '1') {
      menuClose.dataset.bound = '1';
      menuClose.addEventListener('click', function () {
        closeMenu(document);
      });
    }

    if (menuOverlay.dataset.bound !== '1') {
      menuOverlay.dataset.bound = '1';
      menuOverlay.addEventListener('click', function () {
        closeMenu(document);
      });
    }

    root.querySelectorAll('.menu-list a').forEach(function (a) {
      if (a.dataset.bound === '1') return;
      a.dataset.bound = '1';
      a.addEventListener('click', function () {
        closeMenu(document);
      });
    });
  }

  bindDrawer(document);

  // Theme Editor: re-bind when a section is re-rendered.
  document.addEventListener('shopify:section:load', function (e) {
    bindDrawer(e.target);
  });
})();
